<template>
  <FormulateInput
    type="triotecaSelect"
    :name="context.name"
    :options="towns"
    v-model="context.model"
    :placeholder="context.attributes.placeholder"
    :validation="context.validation"
    :validation-messages="context.validationMessages"
  >
  </FormulateInput>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      towns: this.context.options,
    };
  },
  watch: {
    province: function(val) {
      if (val.trim()) {
        this.fetchTowns();
      }
    },
  },
  computed: {
    province() {
      return this.context.attributes.province;
    },
  },
  methods: {
    fetchTowns() {
      this.context.model = null;
      axios.patch(window.location.href, { province: this.province }).then(res => (this.towns = res.data.towns));
    },
  },
};
</script>
